import React from 'react';
import { Form } from '@dashboard/components/Formik';
import usePage from '@dashboard/hooks/usePage';
import { hasRecurringPrice } from '@dashboard/services/getBillingModel';

const DynamicPricingForm = () => {
  const { page, updatePage } = usePage();
  const isMultiPrice = (page.product?.prices || []).filter(p => p.enabled !== false).length > 1;

  return (
    <Form
      autosave
      showState={false}
      initialValues={{
        allowDynamicPrice: page.allowDynamicPrice,
        allowDynamicPlanIterations: page.allowDynamicPlanIterations,
        allowDynamicDiscountedFromPrice: page.allowDynamicDiscountedFromPrice,
        allowDynamicTitle: page.allowDynamicTitle,
        allowDynamicDescription: page.allowDynamicDescription,
        allowDynamicLabel: page.allowDynamicLabel,
        allowDynamicPreselectedPrice: page.allowDynamicPreselectedPrice,
      }}
      fields={[
        {
          type: 'fieldgroup',
          fields: [
            {
              type: 'label',
              label: 'Allow changes to',
              noMargin: true,
              className: '!mb-0',
            },
            {
              name: 'allowDynamicTitle',
              type: 'checkbox',
              label: page.type === 'checkout' ? 'Product title' : 'Title',
              noMargin: true,
            },
            ...(page.type === 'checkout'
              ? [
                  {
                    name: 'allowDynamicPrice',
                    type: 'checkbox',
                    label: 'Price',
                    noMargin: true,
                  },
                  {
                    name: 'allowDynamicDiscountedFromPrice',
                    type: 'checkbox',
                    label: 'Discounted from',
                    noMargin: true,
                  },
                  {
                    name: 'allowDynamicLabel',
                    type: 'checkbox',
                    label: 'Price label',
                    noMargin: true,
                  },
                ]
              : []),
            {
              name: 'allowDynamicDescription',
              type: 'checkbox',
              label: page.type === 'checkout' ? 'Price description' : 'Description',
              noMargin: true,
            },
            ...(page.type === 'checkout'
              ? [
                  {
                    name: 'allowDynamicPlanIterations',
                    type: 'checkbox',
                    label: 'Number of payments',
                    noMargin: true,
                  },
                  {
                    name: 'allowDynamicPreselectedPrice',
                    type: 'checkbox',
                    label: 'Preselected price',
                    noMargin: true,
                  },
                ]
              : []),
          ],
        },
      ]}
      submitButton={{
        label: 'Save',
      }}
      onSubmit={async values => {
        const { data, error } = await updatePage.mutateAsync(values);

        return {
          data,
          error,
        };
      }}
    />
  );
};

export default DynamicPricingForm;
